export const HOSPITALS_MODAL_TEXTS = {
  PROCEDURE_INFO: 'Procedure info',
  GROUP: 'Group',
  CATEGORY: 'Category',
  SUBCATEGORY: 'Subcategory',
  PROCEDURE: 'Procedure',
  TOTAL_CONDUCTED: 'Total conducted',
};
